import { appConst } from "@/settings";

const base = appConst.webApiUrl;

// Public içerik portalı için login gerektirmeyen basit istemci (JWT header yok).
export default {
  async getJson(url: string): Promise<any> {
    const res = await fetch(base + url);
    if (!res.ok) throw new Error(String(res.status));
    return res.json();
  },

  async postJson(url: string, body: any): Promise<any> {
    const res = await fetch(base + url, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body),
    });
    if (!res.ok) throw new Error(String(res.status));
    return res.json();
  },

  async postForm(url: string, form: FormData): Promise<any> {
    const res = await fetch(base + url, { method: "POST", body: form });
    if (!res.ok) throw new Error(String(res.status));
    return res.json();
  },

  // ---- Ajans paneli (X-Agency-Session başlıklı istekler) ----
  async getJsonAuth(url: string, sessionToken: string): Promise<any> {
    const res = await fetch(base + url, {
      headers: { "X-Agency-Session": sessionToken },
    });
    if (!res.ok) throw new Error(String(res.status));
    return res.json();
  },

  async postFormAuth(url: string, form: FormData, sessionToken: string): Promise<any> {
    const res = await fetch(base + url, {
      method: "POST",
      headers: { "X-Agency-Session": sessionToken },
      body: form,
    });
    if (!res.ok) throw new Error(String(res.status));
    return res.json();
  },

  // ---- Marka analiz portalı (X-Brand-Session başlıklı istekler) ----
  async getJsonBrand(url: string, sessionToken: string): Promise<any> {
    const res = await fetch(base + url, {
      headers: { "X-Brand-Session": sessionToken },
    });
    if (!res.ok) throw new Error(String(res.status));
    return res.json();
  },
};
